import { Box, Typography } from '@mui/material';
import background from '../../../../assets/hero_bg.jpg';

export default function Banner({ title }) {
    return (
        <Box id="banner" sx={styles.wrapper}>
            <Box sx={styles.veil} aria-hidden />
            <Typography component="h1" variant="h1" sx={styles.title}>
                {title}
            </Typography>
        </Box>
    );
}

const styles = {
    wrapper: {
        position: 'relative',
        width: '100%',
        py: { xs: 6, md: 8 },
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundImage: `url(${background})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        borderBottom: '2px solid',
        borderColor: 'secondary.main',
    },
    veil: {
        position: 'absolute',
        inset: 0,
        bgcolor: 'primary.main',
        opacity: 0.62,
    },
    title: {
        position: 'relative',
        color: 'common.white',
        px: 2,
        textAlign: 'center',
    },
};
